import React from "react";
import GlobalIcon from "../Icons/GlobalIcon";

const ItemListRepeatable = ({ items }) => {
    return (
      <div className="flex flex-col gap-[16px]">
        {items.map((item, idx) => {
          const { Label, Icon } = item;
  
          return (
            <span
              className="flex flex-row items-center gap-[8px]"
              key={`${Label}_${idx}`}
            >
              <ItemListIcon icon={Icon} />
              <span className="flex-1 text-[#555555] font-normal text-[18px] leading-[28.8px] tracking-[-0.02em]">
                {Label}
              </span>
            </span>
          );
        })}
      </div>
    );
  };
  
  const ItemListIcon = ({ icon }) => {
    const icons = {
      Red_cross: "XIcon",
      Green_check: "CheckedIcon",
    };
  
    const iconsColor = {
      Red_cross: "#e53737",
      Green_check: "#018565",
    };
    if (!icons[icon]) return null;
  
    return (
      <GlobalIcon iconName={icons[icon]} size="XS" color={iconsColor[icon]} />
    );
  };

  export default ItemListRepeatable;